<template>
  <div class="container">
    <div class="container mb50">
      <p v-if="isRequired('bunshou')">内容を入力して保存してください。（<span class="hissu">*</span>印は必須項目です。）</p>
      <ValidationObserver ref="observer" tag="form">
        <table class="table mt40">
          <tbody>
            <div style="color:#ffb6c1">一般設定</div>
            <tr>
              <td class="w400">企業コード<span class="hissu" v-if="isRequired('enterpriseCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseCode') ? 'required' : ''}|numeric|digits:16`">
                  <input type="text" class="form-control enterp-codeInput" :name="itemName.enterpriseCode"
                    v-model="entity.enterpriseCode" :readonly="isReadonly('enterpriseCode')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>企業名称<span class="hissu" v-if="isRequired('enterpriseName')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseName') ? 'required' : ''}|max:40`">
                  <input type="text" class="form-control enterp-codeInput" :name="itemName.enterpriseName"
                    v-model="entity.enterpriseName" :readonly="isReadonly('enterpriseName')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>企業認証コード<span class="hissu" v-if="isRequired('enterpriseAuthCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseAuthCode') ? 'required' : ''}|numeric|digits:4`">
                  <input type="text" class="form-control enterp-codeInput" :name="itemName.enterpriseAuthCode"
                    v-model="entity.enterpriseAuthCode" :readonly="isReadonly('enterpriseAuthCode')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>企業認証パスワード<span class="hissu" v-if="isRequired('enterpriseAuthPass')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseAuthPass') ? 'required' : ''}|docomo_num_digits:16`">
                  <input type="password" class="form-control enterp-codeInput" :name="itemName.enterpriseAuthPass"
                    v-model="entity.enterpriseAuthPass" :readonly="isReadonly('enterpriseAuthPass')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>ドメイン<span class="hissu" v-if="isRequired('domain')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('domain') ? 'required' : ''}|numeric|max:6`">
                  <input type="text" class="form-control enterp-codeInput" :name="itemName.domain"
                    v-model="entity.domain" :readonly="isReadonly('domain')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <!-- <tr :class="this.permissionData.licenseStartDate[this.$session.get('userDiv')]"> -->
            <tr v-if="isDisplay('licenseStartDate')">
              <td>ライセンス開始日<span class="hissu" v-if="isRequired('licenseStartDate')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }" :name="itemName.licenseStartDate"
                  :rules="`${ isRequired('licenseStartDate') ? 'required' : ''}|regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$`">
                  <Datepicker class="inline" v-model="entity.licenseStartDate" input-class="form-control dateInput" :clear-button="true"
                    :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :format="formatStartDate"
                    :language="ja" placeholder="例：2019-01-10" :disabled="isReadonly('licenseStartDate')"></Datepicker>
                  <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr v-if="isDisplay('licenseEndDate')">
              <td>ライセンス終了日<span class="hissu" v-if="isRequired('licenseEndDate')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }" :name="itemName.licenseEndDate"
                  :rules="`${ isRequired('licenseEndDate') ? 'required' : ''}|regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$`">
                  <Datepicker class="inline" v-model="entity.licenseEndDate" input-class="form-control dateInput" :clear-button="true"
                    :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :format="formatEndDate"
                    :language="ja" placeholder="例：2019-01-10" :disabled="isReadonly('licenseEndDate')"></Datepicker>
                  <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr v-if="isDisplay('licenseType')">
              <td>ライセンス種類<span class="hissu" v-if="isRequired('licenseType')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('licenseType') ? 'oneOf:1,2' : ''}`">
                  <select id="licenseType" v-model="entity.licenseType" :name="itemName.licenseType" class="form-control enterp-codeInput" style="width: 250px;">
                    <option :value="0">選択して下さい</option>
                    <option :value="1">パッケージ販売モデル</option>
                    <option :value="2">サービス利用モデル</option>
                  </select>
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr v-if="isDisplay('businessType')">
              <td>業態区分<span class="hissu" v-if="isRequired('businessType')">*</span></td>
              <td>
                <input id="businessType_0" type="radio" name="businessType" :value="0" class="raido_businessType"
                  v-model="entity.businessType" :disabled="isReadonly('businessType')" />
                <label for="businessType_0" class="mr20">携帯</label>
                <input id="businessType_1" type="radio" name="businessType" :value="1" class="raido_businessType"
                  v-model="entity.businessType" :disabled="isReadonly('businessType')" />
                <label for="businessType_1">携帯以外</label>
              </td>
            </tr>
            <tr v-if="isDisplay('inventoryWayDiv')">
              <td>手入力棚卸許可区分<span class="hissu" v-if="isRequired('inventoryWayDiv')">*</span></td>
              <td>
                <input id="radio00" type="radio" name="manualInventoryPermitDiv" :value="0" class="raido_inventoryWayDiv"
                  v-model="entity.manualInventoryPermitDiv" :disabled="isReadonly('inventoryWayDiv')" />
                <label for="radio00" class="mr20">可</label>
                <input id="radio01" type="radio" name="manualInventoryPermitDiv" :value="1" class="raido_inventoryWayDiv"
                  v-model="entity.manualInventoryPermitDiv" :disabled="isReadonly('inventoryWayDiv')" />
                <label for="radio01">不可</label>
              </td>
            </tr>
            <tr v-if="isDisplay('simpleAuthCertificationDiv')">
              <td>簡易認証許可区分<span class="hissu" v-if="isRequired('simpleAuthCertificationDiv')">*</span></td>
              <td>
                <input id="radio02" type="radio" name="simpleAuthenticationDiv" :value="0" class="raido_simpleAuthCertificationDiv"
                  v-model="entity.simpleAuthenticationDiv" :disabled="isReadonly('simpleAuthCertificationDiv')" />
                <label for="radio02" class="mr20">可</label>
                <input id="radio03" type="radio" name="simpleAuthenticationDiv" :value="1" class="raido_simpleAuthCertificationDiv"
                  v-model="entity.simpleAuthenticationDiv" :disabled="isReadonly('simpleAuthCertificationDiv')" />
                <label for="radio03">不可</label>
              </td>
            </tr>
            <tr v-if="isDisplay('inventoryDeleteDiv')">
              <td>棚卸情報削除許可区分<span class="hissu" v-if="isRequired('inventoryDeleteDiv')">*</span> </td>
              <td>
                <input id="radio04" type="radio" name="inventoryDeleteDiv" :value="0" class="raido_inventoryDeleteDiv"
                  v-model="entity.inventoryDeleteDiv" :disabled="isReadonly('inventoryDeleteDiv')" />
                <label for="radio04" class="mr20">可</label>
                <input id="radio05" type="radio" name="inventoryDeleteDiv" :value="1" class="raido_inventoryDeleteDiv"
                  v-model="entity.inventoryDeleteDiv" :disabled="isReadonly('inventoryDeleteDiv')" />
                <label for="radio05">不可</label>
              </td>
            </tr>
            <tr v-if="isDisplay('inventoryCancelDiv')">
              <td>棚卸完了解除許可区分<span class="hissu" v-if="isRequired('inventoryCancelDiv')">*</span></td>
              <td>
                <input id="radio06" type="radio" name="inventoryCancelDiv" :value="0" class="raido_inventoryCancelDiv"
                  v-model="entity.inventoryCancelDiv" :disabled="isReadonly('inventoryCancelDiv')" />
                <label for="radio06" class="mr20">可</label>
                <input id="radio07" type="radio" name="inventoryCancelDiv" :value="1" class="raido_inventoryCancelDiv"
                  v-model="entity.inventoryCancelDiv" :disabled="isReadonly('inventoryCancelDiv')" />
                <label for="radio07">不可</label>
              </td>
            </tr>
            <tr v-if="isDisplay('accountbookDiv') && isMobileEnterprise">
              <td>帳簿未使用区分<span class="hissu" v-if="isRequired('accountbookDiv')">*</span></td>
              <td>
                <input id="radio08" type="radio" name="accountbookDiv" :value="0" class="raido_accountbookDiv"
                  v-model="entity.accountbookDiv" :disabled="isReadonly('accountbookDiv')" v-on:change="clickAccountbookDiv"/>
                <label for="radio08" class="mr20">帳簿あり</label>
                <input id="radio09" type="radio" name="accountbookDiv" :value="1" class="raido_accountbookDiv"
                  v-model="entity.accountbookDiv" :disabled="isReadonly('accountbookDiv')" v-on:change="clickAccountbookDiv"/>
                <label for="radio09">帳簿なし</label>
              </td>
            </tr>
          </tbody>
        </table>
      </ValidationObserver>
      <table class="table mb50">
        <tbody>
          <div v-if="isDisplay('bomAttachDiv')" style="color:#ffb6c1" class="w400">高度な設定</div>
          <tr v-if="isDisplay('bomAttachDiv')">
            <td class="w400"><span>棚卸結果CSVファイル UTF-8設定</span></td>
            <td>
              <input id="radio08" type="radio" name="bomAttachDiv" :value="0" class="raido_bomAttachDiv"
                v-model="entity.bomAttachDiv" :disabled="isReadonly('bomAttachDiv')" />
              <label for="radio08" class="mr20">BOM有</label>
              <input id="radio09" type="radio" name="bomAttachDiv" :value="1" class="raido_bomAttachDiv"
                v-model="entity.bomAttachDiv" :disabled="isReadonly('bomAttachDiv')" />
              <label for="radio09">BOM無</label>
            </td>
          </tr>
          <tr v-if="isDisplay('otherAccessToken')">
            <td class="w400">他システム連携</td>
            <td>
            <span>有効期限</span>
            <Datepicker class="inline" v-model="tokenInfo.expirationDate" input-class="form-control dateInput" :clear-button="!dispTokenBtn"
              :calendar-button="!dispTokenBtn" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :format="formatExpirationDate"
              :language="ja" :disabled="dispTokenBtn"></Datepicker>
            <span>アクセストークン</span>
            <input type="text" class="form-control enterp-tokenInput"
              v-model="tokenInfo.accessToken" :readonly="true" autocomplete="off" />
            <button class="btn btn-primary"
              type="submit" v-show="!dispTokenBtn" @click="publicationToken">発行</button>
            <button class="btn btn-danger"
              type="submit" v-show="dispTokenBtn" @click="deleteToken">削除</button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.save[this.$session.get('userDiv')]"
        type="submit" style="margin-top:0;" @click="save">保存</button>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.cancel[this.$session.get('userDiv')]"
        type="button" style="margin-top:0;" @click="cancel">キャンセル</button>
      <br>
      <br>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.delete[this.$session.get('userDiv')]"
        type="submit" v-if="showDeleteBtn" @click="deleteEnterprise">削除</button>
    </div><!-- .container mb50 -->
  </div><!-- .container -->
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'enterprise-edit',

  components: {
    ValidationProvider,
    ValidationObserver,
    Datepicker
  },

  props: {
    mode: {
      type: String,
      default: null
    },
    enterpriseCode: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      screenTitle: '[マスタ設定] 企業情報設定',
      entity: {
        enterpriseCode: null,
        enterpriseName: null,
        enterpriseAuthCode: null,
        enterpriseAuthPass: null,
        domain: null,
        licenseStartDate: null,
        licenseEndDate: null,
        licenseType: 0,
        businessType: 0,
        manualInventoryPermitDiv: 0,
        simpleAuthenticationDiv: 0,
        inventoryDeleteDiv: 0,
        inventoryCancelDiv: 0,
        bomAttachDiv: 0,
        accountbookDiv: 0
      },
      tokenInfo: {
        accessToken: null,
        expirationDate: ''
      },
      permissionData: {},
      itemName: {},
      ja: ja,
      editMode: this.mode ? this.mode : this.enterpriseCode ? 'update' : 'entry',
      isMobileEnterprise: false,
      param: {
        inventoryName: '',
        sectionCode: '',
        inventoryStatus: '',
        latestFlg: ''
      }
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  computed: {
    showDeleteBtn () {
      return this.$session.get('enterpriseCode') !== this.enterpriseCode
    },
    dispTokenBtn () {
      return Boolean(this.tokenInfo.accessToken)
    }
  },

  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().enterpriseEdit[this.editMode]
    this.itemName = this.item()
    if (this.enterpriseCode) {
      var params = {
        enterpriseCode: this.enterpriseCode,
        enterpriseCreateDateFrom: '',
        enterpriseCreateDateTo: ''
      }
      // 企業情報操作（取得）API
      var response = await this.axios.get('/api/enterprise/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      })
      this.entity = response.data[0]
      this.formatStartDate(this.entity.licenseStartDate)
      if (this.entity.licenseEndDate) {
        this.formatEndDate(this.entity.licenseEndDate)
      }
      if (this.entity.businessType === 0) {
        this.isMobileEnterprise = true
      }
      if (this.isDisplay('otherAccessToken')) {
        // 企業認証取得API（他システム呼出）
        await this.axios.post('/api/auth/otherEnterprise/get', {
          enterpriseCode: this.enterpriseCode
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken')
          }
        }).then((tokenResponse) => {
          // NOTE: 現在フロントは、アクセストークン:企業 = 1:1とし実装。
          if (tokenResponse.data.resultList[0]) {
            this.tokenInfo.accessToken = tokenResponse.data.resultList[0].accessToken
            this.tokenInfo.expirationDate = this.formatExpirationDate(tokenResponse.data.resultList[0].expirationDate)
          }
        })
      }
    }
  },

  methods: {
    formatStartDate (value) {
      this.entity.licenseStartDate = this.$moment(value).format('YYYY-MM-DD')
      return this.entity.licenseStartDate
    },
    formatEndDate (value) {
      this.entity.licenseEndDate = this.$moment(value).format('YYYY-MM-DD')
      return this.entity.licenseEndDate
    },
    formatExpirationDate (value) {
      this.tokenInfo.expirationDate = this.$moment(value).format('YYYY-MM-DD')
      return this.tokenInfo.expirationDate
    },
    isReadonly (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    isDisplay (item) {
      return this.permissionData[item][this.$session.get('userDiv')] !== 'displayNone'
    },
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },
    async save () {
      this.$emit('setMessage', null, false)
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      // 保存処理：企業情報操作（登録・更新）API
      await this.axios.post('/api/enterprise/' + this.editMode, this.entity, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      })
      // 保存完了
      this.$emit('setMessage', '保存処理が完了しました。', false)
    },
    cancel () {
      // キャンセル処理：企業情報一覧画面に遷移
      this.$router.push({ name: 'enterprise-list' })
    },
    async deleteEnterprise () {
      if (confirm('削除してもよろしいですか？')) {
        // 削除処理：企業情報操作（削除）API
        await this.axios.post('/api/enterprise/delete', {
          'enterpriseCode': this.enterpriseCode
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        this.$router.push({ name: 'enterprise-list', params: { message: '削除が完了しました。' } })
      }
    },
    async publicationToken () {
      // 企業認証発行（他システム呼出）
      await this.axios.post('/api/auth/otherEnterprise', {
        enterpriseCode: this.enterpriseCode,
        expirationDate: this.tokenInfo.expirationDate
      }, {
        headers: {
          'Authorization': this.$session.get('accessToken')
        }
      }).then((response) => {
        this.tokenInfo.accessToken = response.data.accessToken
        this.tokenInfo.expirationDate = this.formatExpirationDate(response.data.expirationDate)
        this.$emit('setMessage', '発行処理が完了しました。', false)
      })
    },
    async deleteToken () {
      if (confirm('アクセストークンを削除してもよろしいですか？')) {
        // 企業認証削除（他システム呼出）
        await this.axios.post('/api/auth/otherEnterprise/delete', {
          enterpriseCode: this.enterpriseCode,
          accessToken: this.tokenInfo.accessToken
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken')
          }
        }).then((response) => {
          this.tokenInfo.accessToken = null
          this.tokenInfo.expirationDate = ''
          this.$emit('setMessage', 'アクセストークンの削除処理が完了しました。', false)
        })
      }
    },
    clickAccountbookDiv: async function () {
      // 棚卸情報操作（取得）API
      await this.axios.get('/api/inventory/get', {
        params: this.param,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        const inventoryStatusList = response.data.resultList.map(item => item.inventoryStatus)

        // 棚卸状態 棚卸準備中
        const INVENTORY_STATUS_PENDING = 0
        // 棚卸状態 棚卸中
        const INVENTORY_STATUS_ACTIVE = 1
        // 棚卸状態 完了
        const INVENTORY_STATUS_COMPLETED = 2

        if (inventoryStatusList.includes(INVENTORY_STATUS_PENDING) || inventoryStatusList.includes(INVENTORY_STATUS_ACTIVE) || inventoryStatusList.includes(INVENTORY_STATUS_COMPLETED)) {
          alert('棚卸中のため変更できません。\n全ての棚卸状態を承認済にしてください。')
          location.reload()
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enterp-tokenInput {
  width: 565px;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/EnterpriseEdit.vue